import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Calendar, Users, Video, Mail, Phone, Clock, MessageSquare } from 'lucide-react';

const BuyerInteractionsTab = ({
  myInteractions,
  events,
  exhibitors,
  getStatusBadge,
  joinVideoCall,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dashboard.my_requests_interactions')}</CardTitle>
        <CardDescription>{t('dashboard.track_communication')}</CardDescription>
      </CardHeader>
      <CardContent>
        {myInteractions.length === 0 ? (
          <div className="text-center py-8">
            <MessageSquare className="h-12 w-12 text-slate-400 mx-auto mb-4" />
            <p className="text-slate-600">{t('dashboard.no_interactions')}</p>
            <p className="text-sm text-slate-500 mt-1">{t('dashboard.start_by_requesting')}</p>
          </div>
        ) : (
          <div className="space-y-4">
            {[...myInteractions].sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at)).map((interaction) => {
              const booth = interaction.booth || exhibitors.find(e => e.id === interaction.booth_id);
              const boothName = booth?.company_name || 'Exhibitor (No longer available)';
              const interactionEvent = events.find(e => e.id === booth?.event_id);
              const repName = interaction.rep_name || interaction.rep?.name || 'Representative';
              return (
                <div key={interaction.id} className="border border-slate-200 rounded-lg p-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      {/* Exhibit/Show Name Badge */}
                      <div className="mb-2">
                        <Badge variant="outline" className="text-xs bg-primary/5 border-primary/20">
                          <Calendar className="h-3 w-3 mr-1" />
                          {interactionEvent?.name || t('dashboard.unknown_exhibit')}
                        </Badge>
                      </div>
                      <div className="flex items-center space-x-2 mb-2">
                        <h4 className="font-medium">{boothName}</h4>
                        {getStatusBadge(interaction.status)}
                      </div>
                      {/* Show Rep name if available */}
                      {(interaction.rep_name || interaction.rep?.name) && (
                        <p className="text-xs text-slate-500 mb-1">
                          <Users className="inline h-3 w-3 mr-1" />
                          {t('dashboard.rep')}: {repName}
                        </p>
                      )}
                      <p className="text-sm text-slate-500 mb-2">
                        {interaction.interaction_type === 'call_request' ? (
                          <><Video className="inline h-4 w-4 mr-1" />{t('dashboard.video_call_request')}</>
                        ) : (
                          <><Mail className="inline h-4 w-4 mr-1" />{t('dashboard.documentation_request')}</>
                        )}
                      </p>
                      {interaction.message && (
                        <p className="text-sm text-slate-600 bg-slate-50 p-2 rounded">{interaction.message}</p>
                      )}
                      {interaction.rep_response && (
                        <div className="mt-2 text-sm text-green-600 bg-green-50 p-2 rounded">
                          <strong>{t('dashboard.response')}:</strong> {interaction.rep_response}
                        </div>
                      )}

                      {/* Show Join Call button when video room is ready */}
                      {interaction.status === 'on_call' && interaction.room_url && (
                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 text-green-700">
                              <Video className="h-5 w-5 animate-pulse" />
                              <span className="font-medium">{t('dashboard.video_call_is_ready')}</span>
                            </div>
                            <Button size="sm" onClick={() => joinVideoCall({...interaction, booth})}>
                              <Phone className="h-4 w-4 mr-1" /> {t('dashboard.join_call')}
                            </Button>
                          </div>
                        </div>
                      )}

                      {interaction.status === 'in_queue' && (
                        <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                          <div className="flex items-center gap-2 text-blue-700">
                            <Clock className="h-5 w-5" />
                            <span className="text-sm">{t('dashboard.waiting_exhibitor')}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="text-right text-xs text-slate-500 ml-4">
                      {new Date(interaction.created_at).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BuyerInteractionsTab;
